import { render } from "./RequestPromt.vue?vue&type=template&id=41a588bc"
import script from "./RequestPromt.vue?vue&type=script&lang=js"
export * from "./RequestPromt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__